<script setup>
import { router } from '@/router';
import { Head } from "@vueuse/head";
import { useRoute } from 'vue-router';
import { computed } from 'vue';

import { storeToRefs } from 'pinia';

import { useAuthStore } from '@/stores/auth.store.js';

const authStore = useAuthStore()

const { user } = storeToRefs(authStore);
const route = useRoute();

// Routes that need the full viewport width (the file manager grid)
// flag themselves with `meta.fluid`; everything else stays inside
// the centred Bootstrap container.
const containerClass = computed(() => route.meta?.fluid ? 'container-fluid' : 'container-lg pb-5');

import Nav from '@/components/Nav.vue';
import Alert from '@/components/Alert.vue';
import MfaDisabledWarning from "@/components/MfaDisabledWarning.vue";
import SVGIcons from '@/components/SVGIcons.vue';

</script>

<template>
  <Head>
    <title>Archive Explorer - Impact Journals</title>
  </Head>

    <div v-if="user" class="vh-100 min-vh-100" id="authorized-container">
        <SVGIcons />
        <Nav />

        <div :class="containerClass">
            <Alert />

            <div class="row">
                <div class="col-12 mt-4">
                    <router-view />
                </div>
            </div>
        </div>
        <div><MfaDisabledWarning /></div>
    </div>
</template>

<style>
    #authorized-container {
        min-width: 960px;
    }
</style>